import { STANDARD_SERVICES } from '../../../../constants/services';
import { EServiceId } from '../../../../types/reducers/publishTerms';
import {
  EServiceId as EServices,
  IGetBetsPositionService,
} from '../../../../repositories/auction/entities/AnnouncementsBets/GetBetsPositionService';

interface IGetBetPositionServicesParams {
  serviceIds: EServiceId[];
  currentBet: number;
  isAuctionEnabled: boolean;
}

const SERVICE_MAP: { [serviceId in EServiceId]: EServices } = {
  [EServiceId.top]: EServices.Top3,
  [EServiceId.premium]: EServices.Premium,
  [EServiceId.paid]: EServices.Paid,
  [EServiceId.free]: EServices.Free,
};

export function getBetPositionServices(params: IGetBetPositionServicesParams): IGetBetsPositionService[] {
  const { serviceIds, currentBet, isAuctionEnabled } = params;

  return serviceIds.map(serviceId => {
    const bet = STANDARD_SERVICES.includes(serviceId) && isAuctionEnabled ? currentBet : 0;

    return {
      serviceId: SERVICE_MAP[serviceId],
      bet,
    };
  });
}
